import { all } from 'redux-saga/effects';
import watchForDashboardActions from './dashboard.saga';
export default function* rootSaga() {
    yield all([watchForDashboardActions()]);
}